@if (safeFileName$()) {
  @if (!fill()) {
    <img
      [ngSrc]="safeFileName$()!"
      [width]="width()"
      [height]="height()"
      [alt]="alt() || image()?.alt || media()?.altText"
      [ngSrcset]="ngSrcset()"
      [sizes]="colSizes() || sizes()"
      [loaderParams]="allLoaderParams()"
      [priority]="priority()"
      [attr.loading]="priority() ? null : loading()"
      [ngClass]="(fill() ? 'object-position--' + (image() || media())!.anchor : '') + ' ' + cssClass()"
      [class.object-fit]="fill()"
    />
  }
  @if (fill()) {
    <img
      [ngSrc]="safeFileName$()!"
      [width]="width()"
      [alt]="alt() || image()?.alt || media()?.altText"
      [ngSrcset]="ngSrcset()"
      [sizes]="colSizes() || sizes()"
      [loaderParams]="allLoaderParams()"
      [priority]="priority()"
      [fill]="fill()"
      [attr.loading]="priority() ? null : loading()"
      [ngClass]="(fill() ? 'object-position--' + (image() || media())!.anchor : '') + ' ' + cssClass()"
      [class.object-fit]="fill()"
      style="position: relative"
      class="object-fit"
    />
  }
}
@if (showPlaceholderFallback() && !safeFileName$()) {
  <div
    class="placeholder-image"
    [style.--placeholder-image]="placeholderUrl"
    [style.--placeholder-aspect-ratio]="width() > 0 && height() > 0 ? width() + '/' + height() : 'auto'"
  ></div>
}
